import React from 'react';

const AsyncGeneratePage = React.lazy(() => import('./GenerateContainer'));

export const GeneratePage = () => {
  return <AsyncGeneratePage />;
};
